import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Clock, CalendarDays, Ban } from "lucide-react";
import { TYPE_META, eventColor, fmtRange, fmtDate } from "@/lib/calendar";

export function EventDetail({ ev, onClose, onOpenHomework }) {
  if (!ev) return null;
  const c = eventColor(ev);
  return (
    <Dialog open={!!ev} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="mn max-w-md" data-testid="event-detail-dialog">
        <DialogHeader>
          <span className="w-fit rounded-full px-2.5 py-1 text-[11px] font-bold uppercase tracking-wider" style={{ backgroundColor: c.soft, color: c.hex }}>{TYPE_META[ev.type]?.label}</span>
          <DialogTitle className={`text-xl font-extrabold ${ev.cancelled ? "line-through" : ""}`} data-testid="event-detail-title">{ev.title}</DialogTitle>
        </DialogHeader>
        <div className="space-y-2 text-sm text-[#524B6B]">
          <div className="flex items-center gap-2"><CalendarDays className="h-4 w-4 text-[#4B2BB8]" /> {fmtDate(ev.date, { weekday: "long", day: "numeric", month: "long", year: "numeric" })}</div>
          <div className="flex items-center gap-2"><Clock className="h-4 w-4 text-[#4B2BB8]" /> {fmtRange(ev)}{ev.start ? " (Melbourne time)" : ""}</div>
          {ev.cancelled && <div className="flex items-center gap-2 font-bold text-rose-600"><Ban className="h-4 w-4" /> This class is cancelled</div>}
          {ev.notes && <p className="rounded-xl bg-[#F3F0FF] p-3 text-[#1A1530]" data-testid="event-detail-notes">{ev.notes}</p>}
        </div>
        {ev.type === "deadline" && onOpenHomework && (
          <Button onClick={() => onOpenHomework(ev)} data-testid="event-open-homework" className="mt-2 h-11 rounded-xl ember-gradient font-bold">Open homework</Button>
        )}
      </DialogContent>
    </Dialog>
  );
}
